<section class="page-not-found">
    <div class="page-not-found__main-content">
        <div class="flex-item">
            <h2>Page Not Found</h2>
            <p>The page you requested could not be found</p>
        </div>
    </div>
</section>